import type { TravelInsuredDto } from 'BrokerTsLib/src/dtos'
import type { UseFieldArrayRemove } from 'BrokerTsLib/src/rhf'
import { useFieldArray, useFormContext } from 'BrokerTsLib/src/rhf'

import { FormBody } from '@/containers//forms/FormBody'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { Box, Button, Stack } from '@chakra-ui/react'
import { newUid } from 'BrokerTsLib/src/helpers/global'
import { useEffect, useMemo } from 'react'
import { InsureeRow } from './InsureeRow'

export const defaultInsuree: TravelInsuredDto = {
  isPolicyHolder: false,
  isForeigner: false,
  firstName: '',
  lastName: '',
}

type AdditionalInsureesProps = {
  editableBirthdate?: boolean
  editableBirthnumber?: boolean
  prefix: string
}

export type AdditionalInsureeRowProps = {
  prefix: string
  person: TravelInsuredDto
  contracted: boolean
  remove: UseFieldArrayRemove
  editableBirthdate?: boolean
  editableBirthnumber?: boolean
  originalIndex: number
}

export const InsureesForm = (
  {
    editableBirthdate = false,
    editableBirthnumber = false,
    prefix
  }: AdditionalInsureesProps) => {

  const { isDisabled } = useInsuranceParams()

  const { control } = useFormContext()
  const { fields, remove, append } = useFieldArray({ name: prefix, control: control })

  useEffect(() => {
    if (fields.length == 0)
      append({ ...defaultInsuree, uid: newUid(), id: newUid() } as TravelInsuredDto)
  }, [fields.length])

  const insurees = useMemo(() => {
    return fields
      .map((item, index) => ({ ...item as unknown as TravelInsuredDto, originalIndex: index }))
      .sort((x, y) => Number(y.isPolicyHolder) - Number(x.isPolicyHolder))
  }, [fields]) // JSON.stringify(fields.map(x => x.isPolicyHolder))

  return (
    <FormBody>
      <Stack gap={6}>
        {
          insurees
            .map((field) => {
              return (
                <InsureeRow
                  prefix={prefix}
                  person={field}
                  originalIndex={field.originalIndex}
                  contracted={isDisabled}
                  editableBirthdate={editableBirthdate}
                  editableBirthnumber={editableBirthnumber}
                  remove={remove}
                  key={field.uid} // pokud to bylo pouze pres index, tak nefungoval dobre update hodnot z pojistnika
                />
              )
            })
        }
      </Stack>

      {!editableBirthnumber && !isDisabled &&
        <Box>
          <Button
            type="button"
            // variant="outline"
            onClick={() => append({ ...defaultInsuree, uid: newUid(), id: newUid() } as TravelInsuredDto)}
          >
            Přidat další osobu
          </Button>
        </Box>
      }
    </FormBody>
  )
}